import { ContentfulSettings } from '../types';
import resolveResponse from 'contentful-resolve-response';

export interface OffersRequest {
    offerIds: string[];
    locale: string;
    select: string;
}

export type GetOffersFn = (payload: OffersRequest) => Promise<unknown>;

export function initGetOffersFn({
    accessToken,
    baseUrl,
}: ContentfulSettings): GetOffersFn {
    return async ({ offerIds, locale, select }: OffersRequest) => {
        const url = `${baseUrl}/entries?${new URLSearchParams({
            content_type: 'Offer',
            /**
             * TODO[ARCH]
             * Evaluate using 'include' value 10 (maximum entry hierarchy) instead of the current needed value of 5
             * to support current contentful offer CMS data.
             */
            include: '10',
            'fields.offer_id[in]': offerIds.join(','),
            locale,
            select,
        })}`;

        /**
         * TODO[ARCH]
         * Move headers and fetch call to a common method that all of the public methods can use.
         */
        const headers = {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        };
        const response = await fetch(url, {
            method: 'GET',
            headers,
        });

        if (!response.ok) return Promise.reject(await response.json());
        return resolveResponse(await response.json());
    };
}
